export default __webpack_public_path__ + "static/media/Painting.7c67e6be.jpg";